<template>
  <div class="content">

    <b-row>
      <b-col md="7">
        <h5 class="result-summary-flex rounded" v-translate>Company details</h5>
        <b-card>
          <b-list-group flush class="list-dense">
            <b-list-group-item>
              <span class="user-details"><translate>Agency code</translate></span><span > {{ userData.code }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Agency name</translate></span><span> {{ userData.name }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Group</translate></span><span> {{ userData.groupName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Company name</translate>:</span><span >{{ userData.companyName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>VAT no</translate></span><span> {{ userData.vatNo }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Company no</translate>:</span><span > {{ userData.companyNo }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Address</translate>:</span><span> {{ userData.address }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Bank account</translate></span><span> {{ userData.bankAccount }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Bank</translate></span><span> {{ userData.bankName }}</span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Email</translate></span><span><a :href="'mailto:' + userData.email">{{ userData.email }}</a></span>
            </b-list-group-item>
            <b-list-group-item>
              <span class="user-details"><translate>Phone</translate></span><span> {{ userData.tel }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col md="5">
        <h5 class="result-summary-flex rounded" v-translate>User details</h5>
        <b-list-group>
          <b-list-group-item>
            <span class="user-name"><translate>Username</translate>:</span><span> {{ userData.username }}</span>
          </b-list-group-item>
          <b-list-group-item>
            <span class="user-name"><translate>Name</translate>:</span><span> {{ userData.title }} {{ userData.fname }} {{ userData.lname }}</span>
          </b-list-group-item>
          <b-list-group-item>
            <span class="user-name"><translate>Email</translate>:</span><span> <a :href="'mailto:' + userData.email"> {{ userData.email }}</a></span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
